import { mapGetJobTotalPriceAggregateToDTO } from './dtos/jobsTotalPricingDtoMapper'
import { Id } from '../../../types/definitions'
import { ISOToTimestamp } from 'utils/grpc-util'
import { Interval } from '@taxfyle/api-internal/shared/types/interval_pb'
import { JobStatsAPI } from '../../job-stats/API'
import { GetJobTotalPriceAggregationsRequest } from '@taxfyle/api-internal/internal/job_stats_pb'

interface GetJobTotalPriceAggregationsParams {
  workspaceId: Id
  contractStartDate: Date | null
  contractEndDate: Date | null
}

/**
 * Manages API interaction for the Firm Dashboard.
 */
export default class FirmDashboardStore {
  /**
   * Constructor
   * @param jobStatsAPI jobs admin dotnet API.
   */
  constructor(private jobStatsAPI: JobStatsAPI) {}

  /**
   * Gets the total sum for submitted and closed jobs pricing.
   */
  getJobsTotalPricing = async ({
    workspaceId,
    contractStartDate,
    contractEndDate,
  }: GetJobTotalPriceAggregationsParams) => {
    const request = new GetJobTotalPriceAggregationsRequest().setWorkspaceId(
      Id.assert(workspaceId),
    )

    if (contractStartDate && contractEndDate) {
      request.setDateRange(
        new Interval()
          .setStartTime(ISOToTimestamp(contractStartDate.toISOString()))
          .setEndTime(ISOToTimestamp(contractEndDate.toISOString())),
      )
    }

    return await this.jobStatsAPI
      .getJobTotalPriceAggregations(request)
      .then((protoObject) =>
        mapGetJobTotalPriceAggregateToDTO(protoObject.toObject()),
      )
  }
}
